import "@babel/polyfill";//promise　やarrayfromも変換

import "../commoncss/pc_menu.css";
import "../commoncss/link.css";
import "../commoncss/loading.css";
import "./profile.css";
import {getDevice} from "../commonjs/device.js";  
import {google} from "../commonjs/google.js";
import {load_off} from "../commonjs/load.js";


window.onload = function(){
    load_off();
    google();
    const device = getDevice();
    const language = document.getElementById(`language`);
    const japanese = document.getElementById(`japanese`);
    const english = document.getElementById(`english`);
    const other = document.getElementById(`other`);
    const change_lan = document.getElementById(`change_lan`);
    
    const other_link = document.getElementById(`other_content`).getElementsByTagName(`ul`);
    const close = document.getElementsByClassName(`close`);
    console.log(other_link);

    
    class History{
        constructor(hide,show,next_lan){
            this.button = change_lan;
            this.hide = hide;
            this.show = show;
            this.next_lan = next_lan; 
        }
        
        handleEvent(){
            this.button.removeEventListener(`click`,this);
            const disappear = this.hide.animate({ opacity:[1,0]},{
                direction: `alternate`,
                duration: 1000,
                fill:`forwards`,
            });
            
            const change = this.button.animate({ opacity:[1,0]},{
                direction: `alternate`,
                duration: 1000,
                fill:`forwards`,
            });
            
            disappear.addEventListener(`finish`,()=>{
                this.show.animate({opacity:[0,1]},{
                    direction: `alternate`,
                    duration: 1000,
                    fill:`forwards`,
                    delay: 200,
                });
            });
            
            change.addEventListener(`finish`,()=>{
                this.button.innerHTML = this.next_lan;
                this.button.animate({opacity:[0,1]},{
                    direction: `alternate`,
                    duration: 1000,
                    fill:`forwards`,
                    delay: 200,
                });
            });
            this.add_event();
        }
        
        add_event(){
            this.button.addEventListener(`click`,this.obj);
        }
        
    }
    
    const japan_text = new History(japanese,english,`Japanese`);
    const english_text = new History(english,japanese,`English`);
    japan_text.button.addEventListener(`click`,japan_text);
    
    
    japan_text.obj = english_text;
    english_text.obj = japan_text;
    
    
    class Other_content{
        constructor(trigger,direction){
            this.trigger = trigger;
            this.elm = other_link[0];
            this.direction = direction;
        }
        
        handleEvent(){
            this.trigger.removeEventListener(`click`,this);
            const position = parseFloat(document.defaultView.getComputedStyle(this.elm).top);
            this.elm.animate({top: [position+`px`,position+this.direction+`px`]},{
                    direction: `alternate`,
                    duration: 1000,
                    fill:`forwards`,
            });
            this.add_event();
        }
        
        add_event(){
            this.obj.trigger.addEventListener(`click`,this.obj);
        }
    }
    
    
    
    const show_content = new Other_content(other,-50);
    const hide_content = new Other_content(close[0],50);
    show_content.trigger.addEventListener(`click`,show_content);
    
    show_content.obj = hide_content;
    hide_content.obj = show_content;
    
    
}